// extracted by mini-css-extract-plugin
export default {"root":"VideoSuggestionsPanel_root__BrMsN","title":"VideoSuggestionsPanel_title__4IQ4K","list":"VideoSuggestionsPanel_list__tvyPL"};